import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=0b4e2f93&scoped=true"
import script from "./inquiry.vue?vue&type=script&lang=js"
export * from "./inquiry.vue?vue&type=script&lang=js"
import style0 from "./inquiry.vue?vue&type=style&index=0&id=0b4e2f93&prod&lang=scss&scoped=true"
import style1 from "./inquiry.vue?vue&type=style&index=1&id=0b4e2f93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e2f93",
  null
  
)

export default component.exports